import type { TimeseriesDataSet } from '../../../../DataProvider/types';
import type { DataConverter, SheetData } from '../types';
import { formatColumnName } from './utils';

/**
 * Convert TimeseriesDataSet to volume chart format
 * Used for volume charts that show active, new, and removed series
 */
export const convertVolumeDataToSheet: DataConverter<TimeseriesDataSet> = ({
  data,
}): SheetData[] => {
  const allDates = Array.from(
    new Set(
      data.data.flatMap((series) =>
        series.timeseries.map((point) => point.date.split('T')[0])
      )
    )
  ).sort();

  const seriesMap = new Map(
    data.data.map((series, index) => {
      const seriesName = (() => {
        if (index === 0) return 'Active';
        if (index === 1) return 'New';
        if (index === 2) return 'Removed';
        return series.dim;
      })();

      return [
        seriesName,
        new Map(
          series.timeseries.map((point) => [
            point.date.split('T')[0],
            point.value,
          ])
        ),
      ];
    })
  );

  return allDates.map((date) => ({
    Date: date ?? '',
    ...Object.fromEntries(
      data.data.map((series, index) => {
        const seriesName = (() => {
          if (index === 0) return 'Active';
          if (index === 1) return 'New';
          if (index === 2) return 'Removed';
          return series.dim;
        })();

        return [
          formatColumnName(seriesName),
          seriesMap.get(seriesName)?.get(date) ?? null,
        ];
      })
    ),
  }));
};
